// extracted by mini-css-extract-plugin
export default {"customOption":"WkIu0BNzeZijK1z4RQJR","selected":"ahRKNR8zO6eDlQWl6OMj"};